import { BaseService } from "../base-service";
import { API_BASE_URL } from "../../config";
import type { Country } from "./locations.types";

export class LocationsService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  public async getCountries(): Promise<Country[]> {
    const response = await this.fetch("/locations/countries");
    if (!response.ok) throw new Error(`Locations API error: ${response.status}`);
    return response.json();
  }

  public async getPhoneCodes(): Promise<string[]> {
    const response = await this.fetch("/locations/phonecodes");
    if (!response.ok) throw new Error(`Locations API error: ${response.status}`);
    return response.json();
  }

  public async getStates(iso2: string): Promise<string[]> {
    const response = await this.fetch(`/locations/${encodeURIComponent(iso2)}/states`);
    if (!response.ok) throw new Error(`Locations API error: ${response.status}`);
    return response.json();
  }

  public async getCities(iso2: string, state: string): Promise<string[]> {
    const response = await this.fetch(
      `/locations/${encodeURIComponent(iso2)}/states/${encodeURIComponent(state)}/cities`
    );
    if (!response.ok) throw new Error(`Locations API error: ${response.status}`);
    return response.json();
  }
}
